import { useToast } from "@chakra-ui/react";
import { ShowErrorNotFound } from "components/Toast/Index";
import { format } from "date-fns-tz";
import { pt } from "date-fns/locale";
import { formatDateUs } from "helpers/formated";
import { useHistory } from "react-router-dom";
import { parseScheduleSupplierDrawer } from "helpers/Grid/ScheduleSupplierDrawerParse";
import { ITableHeader } from "Interfaces/Components/TableGrid";
import { IScheduleSupplierContext } from "Interfaces/Providers/Supplier/ScheduleSupplier";
import fileDownload from "js-file-download";
import { createContext, ReactNode, useCallback, useState } from "react";
import inventory from "services/inventory";
import schedule from "services/Supplier/schedule";
import Swal from "sweetalert2";
import { useImmer } from "use-immer";
import ScheduleDrawerHeader from "variables/Header/ScheduleDrawer";
import ScheduleSupplierDrawerHeader from "variables/Header/Supplier/ScheduleSupplierDrawer";

interface Auth0ProviderProps {
  children: ReactNode;
}

const ScheduleSupplierProvider = ({ children }: Auth0ProviderProps) => {
  const toast = useToast();

  const [loading, setLoading] = useState(false);
  const [loadingFerragem, setLoadingFerragem] = useState(false);
  const [loadingChaparia, setLoadingChaparia] = useState(false);
  const [loadingCalendar, setLoadingCalendar] = useState(false);
  const [loadingDrawer, setLoadingDrawer] = useState(false);
  const [loadingAvaliableData, setLoadingAvaliableData] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [isFirstData, setFirstData] = useState(true);

  const [filename, setFilename] = useState("Calendario");
  const [dateFerragem, setDateFerragem] = useState("");
  const [dateChaparia, setDateChaparia] = useState("");

  const [data, updateData] = useImmer<any[]>([]);
  const [scheduleSelect, setScheduleSelect] = useImmer<any[]>([]);
  const [datesAvaliable, updateDateAvaliable] = useImmer<any[]>([]);
  const [datesSchedulesModify, updateDatesSchedulesModify] = useImmer<any[]>(
    []
  );
  const [idSelectDate, setSelectIdDate] = useState(0);
  const [headers] = useImmer<ITableHeader[]>(ScheduleSupplierDrawerHeader);
  const history = useHistory();
  const [selecteds, setSelecteds] = useImmer([] as any);

  const getData = useCallback(
    async (start: any, end: any) => {
      setLoadingCalendar(true);
      setFirstData(false);
      setDateChaparia(start);

      const valueStore = JSON.parse(localStorage.getItem("storeUser"));

      schedule
        .getScheduleCalendar(valueStore?.value, start, end)
        .then((response) => {
          updateData(response.data?.data);
          setLoadingCalendar(false);
        })
        .catch(() => {
          setLoadingCalendar(false);
        });
    },
    [updateData]
  );

  const getScheduleById = useCallback(
    async (id: number) => {
      setLoadingDrawer(true);
      setFirstData(false);

      schedule
        .getScheduleCalendarById(id)
        .then((response) => {
          setScheduleSelect(response.data?.data);
          setLoadingDrawer(false);
        })
        .catch(() => {
          setLoadingDrawer(false);
        });
    },
    [setScheduleSelect, setLoadingDrawer]
  );

  const getScheduleAvaliableDateById = useCallback(
    async (productId: any, document: any, supplierId: any) => {
      setLoadingAvaliableData(true);
      setFirstData(false);

      schedule
        .getScheduleDateAvaliableById(productId, document, supplierId)
        .then((response) => {
          updateDateAvaliable(response.data?.data);
          setLoadingAvaliableData(false);
        })
        .catch(() => {
          setLoadingAvaliableData(false);
        });
    },
    [updateDateAvaliable]
  );

  const saveReSchedulePatch = useCallback(async () => {
    setFirstData(false);
    const transformedArray = datesSchedulesModify.map((item, index) => ({
      id: item.id,
      schedulingQuantity: item.schedulingQuantity || 0,
    }));

    const obj = {
      schedulings: transformedArray,
    };

    schedule
      .saveReSchedulePatch(obj)
      .then((response) => {
        toast({
          title: "Salvo com Sucesso.",
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      })
      .catch(() => {
        toast({
          title: "Error ao Salvar.",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      });
  }, [datesSchedulesModify, toast]);

  const confirmReSchedule = useCallback(
    async (obj: any) => {
      setLoading(true);
      setFirstData(false);

      schedule
        .confirmReSchedule(obj)
        .then((response) => {
          toast({
            title: "Agendamento confirmado com Sucesso.",
            status: "success",
            duration: 3000,
            position: "top",
            isClosable: true,
          });
          setTimeout(() => {
            window.location.href = "#" + "/supplier/agendamentos";
            window.location.reload();
            // history.push("/supplier/agendamentos");
          }, 200);
        })
        .catch((error: any) => {
          setLoading(false);
          const { data } = error.response;

          const message =
            data.message !== null
              ? data.message
              : "Ocorreu um problema interno. Tente novamente mais tarde";
          toast({
            title: "Error",
            description: message,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        });
    },
    [dateChaparia, getData, toast]
  );

  const deleteData = useCallback(async (id: number) => {
    setLoading(true);
    setFirstData(false);
    let newParams = {};

    inventory
      .deleteInventory(id)
      .then((response) => {
        // getData();
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const cancelSchedule = useCallback(async () => {
    setLoading(true);
    setFirstData(false);
    let newParams = {};
    schedule
      .cancelSchedule({ ids: selecteds })
      .then((response) => {
        var today = new Date(dateChaparia);
        updateData([]);

        getData(
          formatDateUs(new Date(today.getFullYear(), today.getMonth() + 1, 1)),
          formatDateUs(new Date(today.getFullYear(), today.getMonth() + 2, 0))
        );
        toast({
          title: "Cancelamento com Sucesso.",
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      })
      .catch(() => {
        setLoading(false);
        toast({
          title: "Error ao cancelar.",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      });
  }, [dateChaparia, getData, selecteds, toast]);

  const handleUpdateWanted = useCallback(
    async (index: number, wanted: number | string) => {
      const purchase = scheduleSelect.filter((x) => x.id === Number(index));
      const ind = scheduleSelect.findIndex((x) => x.id === Number(index));
      let purchases = [...scheduleSelect];
      if (purchase[0]?.schedulingQuantity) {
        // verifica se a propriedade existe
        purchase[0] = {
          ...purchase[0],
          schedulingQuantity: wanted,
        };
      }

      purchases = [...purchases]; // important to create a copy, otherwise you'll modify state outside of setState call
      purchases[ind] = purchase[0];
      const newData = purchases;
      setScheduleSelect((draft) => {
        return draft.filter((item) => item.status === 99).concat(newData);
      });

      updateDatesSchedulesModify((prevArray) => {
        debugger;
        const objectIndex = prevArray.findIndex(
          (obj) => obj.id === purchase[0].id
        );
        if (objectIndex !== -1) {
          // If the object exists, replace it in the array
          const updatedArray = [...prevArray];
          updatedArray[objectIndex] = purchase[0];
          return updatedArray;
        } else {
          // If the object does not exist, add it to the array
          return [...prevArray, purchase[0]];
        }
      });

      // setLoading(false)
    },
    [scheduleSelect, setScheduleSelect, updateDatesSchedulesModify]
  );

  const downloadExport = useCallback(
    async (initDate: any, endDate: any, sector: any) => {
      Swal.fire({
        title: "Exportar dados!",
        html: "Aguarde um momento<b></b>.",
        timerProgressBar: true,
        timer: 99999,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const valueStore = JSON.parse(localStorage.getItem("storeUser"));

      schedule
        .getScheduleDashboarExport(valueStore?.value, initDate, endDate, sector)
        .then((response) => {
          fileDownload(
            response.data,
            filename +
              "-" +
              sector +
              "-" +
              format(new Date(endDate), "MMMM", { locale: pt }) +
              ".csv"
          );
          Swal.close();
        })
        .catch((error: any) => {
          const statusCode = error.response.status;
          if (statusCode === 404) {
            ShowErrorNotFound();
          }
          Swal.close();

          setLoading(false);
        });
    },
    []
  );

  const handleSelect = useCallback(
    async (index: any) => {
      const supply = index;
      if (!selecteds.includes(supply)) {
        setSelecteds([...selecteds, supply]);
      } else {
        setSelecteds(selecteds.filter((prop: any) => prop !== supply));
      }
    },
    [setSelecteds, selecteds]
  );

  const handleSelectAll = () => {
    if (selecteds.length < scheduleSelect.length) {
      const res = [];
      for (const item of scheduleSelect) {
        res.push(item.id);
      }
      setSelecteds(res);
    } else {
      setSelecteds([]);
    }
  };

  return (
    <ScheduleSupplierContext.Provider
      value={{
        loading,
        loadingAvaliableData,
        data,
        loadingCalendar,
        isFirstData,
        headers,
        scheduleSelect: parseScheduleSupplierDrawer(scheduleSelect),
        datesAvaliable,
        idSelectDate,
        loadingDrawer,
        loadingModal,
        datesSchedulesModify,
        loadingFerragem,
        loadingChaparia,
        dateChaparia,
        dateFerragem,
        selecteds,
        cancelSchedule,
        handleSelect,
        handleSelectAll,
        handleUpdateWanted,
        setSelectIdDate,
        getScheduleAvaliableDateById,
        getScheduleById,
        getData,
        deleteData,
        confirmReSchedule,
        setSelecteds,
        saveReSchedulePatch,
        downloadExport,
        setScheduleSelect,
      }}
    >
      {children}
    </ScheduleSupplierContext.Provider>
  );
};

export default ScheduleSupplierProvider;
export const ScheduleSupplierContext = createContext<IScheduleSupplierContext>(
  {} as IScheduleSupplierContext
);
